import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=2f8fa4d9&scoped=true"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=2f8fa4d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fa4d9",
  null
  
)

export default component.exports